module.exports = __webpack_public_path__ + "media/images/help_correction_5-4a65cf433e748c94faa2ac219684d862.png";